export const THREAD_REPORTS = [
    {
        key: 'summary',
        label: 'Summary PDF',
        description: 'Expenses grouped by vendor, with what the client has paid and still owes.',
    },
    {
        key: 'itemized',
        label: 'Itemized PDF',
        description: 'Every expense line, with its vendor, price, paid and balance.',
    },
    {
        key: 'timeline',
        label: 'Timeline',
        description: 'The running order — one PDF per timeline you choose.',
        selects: 'timeline',
    },
    {
        key: 'floor-plan',
        label: 'Floor plan',
        description: 'Tables, seats and objects — one PDF per plan you choose.',
        selects: 'floorPlan',
    },
    {
        key: 'vendor-list',
        label: 'Vendor list',
        description: 'Every vendor on the event with their phone numbers and emails.',
    },
];
const BY_KEY = new Map(THREAD_REPORTS.map((report) => [report.key, report]));
export function threadReport(key) {
    return BY_KEY.get(key);
}
export function isThreadReportKey(key) {
    return BY_KEY.has(key);
}
//# sourceMappingURL=thread-report.js.map